import { Component, OnInit, Input } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import * as State from '@shared/state';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-barcode',
    templateUrl: './barcode.shared.component.html',
    styleUrls: ['./barcode.shared.component.scss']
})
export class BarcodeComponent implements OnInit {
    private _imgLoaded: boolean = false;

    @Input() public memberId: number;
    @Input() public barcodeType: OLO.Enums.BARCODE_SYMBOLOGY = OLO.Enums.BARCODE_SYMBOLOGY.CODE_QR;
    @Input() public showCardNumber: boolean = true;

    public cardNo$: Observable<string>;
    public image$: Observable<State.IMemberCardBarcodeImage>;

    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.cardNo$ = this.controllers.members.getCurrentMemberCardNumber$();
        this.image$ = this.controllers.loyalty.getMemberLoyaltyCardBarcode$(this.memberId, this.barcodeType);
    }

    public handleOnCodeLoaded($event: Event): void {
        this._imgLoaded = true;
    }

    public handleCodeClick($event: MouseEvent): void {
        if (this.imgLoaded) {
            const w = window.open(($event.currentTarget as HTMLImageElement).src, '_blank');
            w.focus();
        }
    }

    public get imgLoaded(): boolean {
        return this._imgLoaded;
    }
}
